package theme

import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.text.font.FontFamily
import banko.composeapp.generated.resources.Res
import banko.composeapp.generated.resources.fredoka
import banko.composeapp.generated.resources.luckiest_guy
import org.jetbrains.compose.resources.Font

/** Rounded, friendly sans used across the whole UI. */
@Composable
fun bankoUiFontFamily(): FontFamily = FontFamily(Font(Res.font.fredoka))

/** Chunky display font for hero moments — the logo and the pot. */
@Composable
fun bankoDisplayFontFamily(): FontFamily = FontFamily(Font(Res.font.luckiest_guy))

/**
 * Provides Fredoka as the default font for ALL text, so even bare `Text(fontSize = ...)` calls
 * (which ignore [Typography] and fall back to LocalTextStyle) use it. Individual Text can still
 * override fontFamily (e.g. the logo and pot use [bankoDisplayFontFamily]).
 */
@Composable
fun ProvideBankoTextStyle(content: @Composable () -> Unit) {
    CompositionLocalProvider(
        LocalTextStyle provides LocalTextStyle.current.copy(fontFamily = bankoUiFontFamily()),
        content = content,
    )
}

/** Material typography with every style switched to [bankoUiFontFamily]. */
@Composable
fun bankoTypography(): Typography {
    val ui = bankoUiFontFamily()
    val base = Typography()
    return base.copy(
        displayLarge = base.displayLarge.copy(fontFamily = ui),
        displayMedium = base.displayMedium.copy(fontFamily = ui),
        displaySmall = base.displaySmall.copy(fontFamily = ui),
        headlineLarge = base.headlineLarge.copy(fontFamily = ui),
        headlineMedium = base.headlineMedium.copy(fontFamily = ui),
        headlineSmall = base.headlineSmall.copy(fontFamily = ui),
        titleLarge = base.titleLarge.copy(fontFamily = ui),
        titleMedium = base.titleMedium.copy(fontFamily = ui),
        titleSmall = base.titleSmall.copy(fontFamily = ui),
        bodyLarge = base.bodyLarge.copy(fontFamily = ui),
        bodyMedium = base.bodyMedium.copy(fontFamily = ui),
        bodySmall = base.bodySmall.copy(fontFamily = ui),
        labelLarge = base.labelLarge.copy(fontFamily = ui),
        labelMedium = base.labelMedium.copy(fontFamily = ui),
        labelSmall = base.labelSmall.copy(fontFamily = ui),
    )
}
